






























import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin, TabContainableMixin } from "../../../system/mixins";
import { EditingDocument } from "../../../document/editor";
import TabSelector from "../../../system/selectors/TabSelector.vue";
import {
  ObjectDebugger,
  AttributesDebugger,
  TestsDebugger,
} from "./contents";

@Component({
  components: {
    TabSelector,
    ObjectDebugger,
    AttributesDebugger,
    TestsDebugger,
  }
})
export default class DebugTool extends Mixins(ModelEditableMixin, TabContainableMixin) {
  static readonly Tabs: {[key: string]: any} = {
    object: {
      name: "object",
      description: "オブジェクトのデバッガ。",
    },
    attributes: {
      name: "attributes",
      description: "文書属性のデバッガ。",
    },
    tests: {
      name: "tests",
      description: "各種テスト。",
    },
  };
  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly objectTab: any = DebugTool.Tabs.object;
  readonly attributesTab: any = DebugTool.Tabs.attributes;
  readonly testsTab: any = DebugTool.Tabs.tests;

  editingSource: EditingDocument;

  @Prop()
  isDebugging: boolean;

  mounted(): void {
    this.initializeTabs();
  }

  initializeTabs(): void {
    this.tabs = [
      this.objectTab,
      this.attributesTab,
      this.testsTab,
    ];
    const selectedTab = Enumerable.from(this.tabs)
      .firstOrDefault(t => t === this.selectedTab);
    this.selectedTab = selectedTab
      ? selectedTab
      : this.tabs[0];
  }
  get formatName(): string {
    return this.editingSource.attributes.format.name;
  }
}
